import { TableActions } from 'components/Table';
import { Edit, Visibility, Delete } from '@mui/icons-material';
import {
  createOrganisationEditRoute,
  createOrganisationViewRoute,
} from 'adminConstants/routes';
import { useHasPermissions } from 'hooks/ui/usePermissions';
import { RolePermission } from 'further-types/admin-user-role';

type TableActionsProps = {
  row: any;
  deleteDisclosure: {
    stageAction: (props: { id: string; hasLinks: boolean }) => void;
  };
  useOrganisaionSpecificEditPermissions: boolean;
};

const OrganisationTableActions: React.FC<TableActionsProps> = ({
  row,
  deleteDisclosure,
  useOrganisaionSpecificEditPermissions,
}) => {
  const [editPermission, deletePermission] = useHasPermissions([
    RolePermission.EditOrganisations,
    RolePermission.DeleteOrganisations,
  ]);

  const organisationSpecificEditDisabled =
    useOrganisaionSpecificEditPermissions && !row.canBeEditedByFirm;

  return (
    <TableActions
      showAsDropdown
      actions={[
        {
          label: 'View organisation',
          icon: Visibility,
          color: 'primary',
          link: createOrganisationViewRoute(row?._id),
        },
        {
          label: 'Edit',
          icon: Edit,
          color: 'primary',
          link: createOrganisationEditRoute(row?._id),
          visible: editPermission && !organisationSpecificEditDisabled,
        },
        {
          label: 'Delete',
          icon: Delete,
          color: 'error',
          visible: deletePermission,
          disabled: row?.deleteForbidden,
          tooltip: row?.deleteForbidden
            ? `This organisation is linked with advisers in other firms, so it cannot be deleted.`
            : undefined,
          onClick: () =>
            deleteDisclosure.stageAction({
              id: row._id,
              hasLinks: row.hasLinks,
            }),
        },
      ]}
    />
  );
};

export default OrganisationTableActions;
